/*
  Session Per Tab

  This is a middleware that prevents
  cloning subsession when the user has
  copy & pasted the url to another tab.
*/

function getParams(url) {
  const params = {};
  const parser = document.createElement('a');

  parser.href = url;

  const query = parser.search.substring(1);
  const vars = query.split('&');

  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=');

    params[pair[0]] = decodeURIComponent(pair[1]);
  }

  return params;
}

function createParamsToAppend() {
  const paramsObj = getParams(window.location.href);
  let paramsString = '';

  if (Object.keys(paramsObj).length > 0) {
    for (const param in paramsObj) {
      if (paramsObj.hasOwnProperty(param)) {
        const paramValue = paramsObj[param];

        if (param !== 'subSessionId') {
          paramsString = `${ paramsString }&${ param }=${ paramValue }`;
        }
      }
    }
  }

  return paramsString.substr(1);
}

function sessionPerTab() {
  const { subSessionId = '' } = window._app.page || {};
  const isNewTab = sessionStorage.getItem('isNewTab');
  const subSessionIdStored = sessionStorage.getItem('subSessionId');
  const nextParams = createParamsToAppend();
  const newHref = `/?${ nextParams }`;

  if(!isNewTab) {

    window.sessionStorage.setItem('isNewTab', true);
    window.location.href = newHref;

  } else if(!subSessionIdStored) {

    window.sessionStorage.setItem('subSessionId', subSessionId);

  } else if(subSessionIdStored !== subSessionId) {

    window.sessionStorage.setItem('isNewTab', true);
    window.sessionStorage.setItem('subSessionId', '');
    window.location.href = newHref;
  }

}

export default sessionPerTab;



// WEBPACK FOOTER //
// ./js/modules/sessionPerTab.js